import {
  capitalizeString,
  formatToDateWithWeekDay,
  formatDate,
} from 'features/order-tracker/utils';
import { DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';

import {
  MAX_ITEMS_IN_POP_UP,
  arrivedWithYouEventCodes,
} from './constants';

export class TrackingEventsService {
  static transformResponse(
    { mailPieces, trackingresponse }: dto.TrackingEventsDTO,
  ): common.DeliveryTrackingInfo | '' {
    if (trackingresponse?.trackingdetails?.trackingdetail?.trackingevents) {
      const {
        trackingdetails: {
          trackingdetail: {
            trackingevents: {
              trackingevent,
            },
            trackingnumber,
          },
        },
      } = trackingresponse;
      const { type, date } = trackingevent[0];

      return this.unifyResponse('', type, date, trackingnumber, trackingevent);
    }

    if (mailPieces?.events) {
      const {
        summary: {
          oneDBarcode = '',
        },
        events: [
          {
            eventCode = '',
            eventName = '',
            eventDateTime = '',
          },
        ],
      } = mailPieces;

      return this.unifyResponse(eventCode, eventName, eventDateTime, oneDBarcode, mailPieces.events);
    }

    return '';
  }

  static unifyResponse = (
    eventCode: string,
    eventName: string,
    lastEventDateTime: string,
    TrackingReference: string,
    events: dto.TrackingEvent[] | dto.TrackingEventAlt[],
  ): common.DeliveryTrackingInfo => {
    const deliveryStatus = TrackingEventsService.isArrivedWithYou(eventCode, eventName)
      ? DELIVERY_STATUSES.Delivered
      : DELIVERY_STATUSES.InProgress;

    return {
      status: deliveryStatus,
      lastEventDateTime: formatToDateWithWeekDay(lastEventDateTime),
      trackingReference: TrackingReference,
      events: TrackingEventsService.addPopUpContent(events),
    };
  };

  static isArrivedWithYou = (eventCode: string, eventName: string): boolean => eventCode === ''
    ? eventName.toUpperCase().includes(DELIVERY_STATUSES.Delivered.toUpperCase())
    : arrivedWithYouEventCodes.includes(eventCode.toUpperCase());

  static addPopUpContent = (events: dto.TrackingEvent[] | dto.TrackingEventAlt[]): common.DeliveryTrackingEvent[] =>
    events.slice(0, MAX_ITEMS_IN_POP_UP)
      .map(event => {
        const name = event.eventName || event.type;
        const date = event.eventDateTime || event.date;

        return {
          name: capitalizeString(name),
          date: formatDate('YYYY-MM-DD HH:mm:ss', date),
        };
      });
}
